<style scoped lang="scss">
  // @import "../user";
  .order{
    margin-top: 20px;
    width: 100%;
    .products{
      display: flex;
      flex-wrap: wrap;
      li{
        width: calc((100% - 15px * 5) / 5);
        // width:200px;
        padding:15px 10px 10px 10px;
        border: 1px solid #E4E6EA;
        margin-right: 15px;
        margin-top: 15px;
        &:last-child{
          // border-bottom: 0;
        }
        .img-box{
          img{
            max-width: 100%;
            height:100%;
          }
        }
        .info{
          flex:1;
        }
        .title{
          font-size: 12px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: center;
          height: 25px;
          line-height: 25px;
        }
        .icon {
          border:1px solid #e8e8e8;
          border-radius:5px;
          padding:2px;
        }
        .cursor {
          cursor:pointer
        }

      }
      li:hover {
        border-color: #dddddd;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
      }
      dl{
        display: flex;
        flex-wrap: wrap;
        dd{
          width:25%;
          margin-top:8px;
          label{
            color:#999;
          }
        }
      }
    }
  }
  .products-lists{
    display: flex;
    .products{
      // flex:1;
      width: calc((100% - 15px * 4) / 5);
      border-right:1px solid #E4E6EA;
    }
    .status{
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding:0 10px;
      text-align: center;
      flex-shrink: 0;
      width:150px;
      dl{
        label{
          color:#999;
        }
        dd{
          display: block;
          margin:10px 0;
        }
      }
    }
  }
  .product{
    display: flex;
    align-items: center;
    .info{
      margin-left: 20px;
      text-align: left;
      flex:1;
    }
    .title{
      font-size: 14px;
      font-weight: bold;

    }
  }
  .el-input-number{
    width:120px;
  }
  @media screen and (max-width: 640px) and (min-width: 600px){
    .order .products li{
      width: 100%!important;
    }
    .li_div{
      display: -webkit-box;
    }
    .order .products li  .icon{
      display: block!important;
    }
    .order .products .img-box{
      width: 150px;
      float: left;
    }
    .order .products li .title{
      float: left;
      margin-top: 15px;
      margin-left: 15px;
    }
    .order .products li .jiage{
      margin-top: 15px;
      display: block!important;
      overflow: auto;
    }
    .order .products li .jiage p{
      float: left;
      margin-right: 10px;
    }
    .chakan1{
      display: none;
    }
    .chakan{
      margin-top: 30px;
      display: block;
    }
    .jia_a{
      overflow: auto;
      float: right;
    }
    .order .products li .info{
      overflow: auto;
    }
    .order .products li .chakan .icon{
      width: 60px;
      height: 25px;
      margin-right: 25px;
      text-align: center;
    }
    .order .products li .chakan .icon:last-child{
      margin-right: 0;
    }
    .order .products li .chakan .div_a{
      display: flex;
      overflow: auto;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
  }
  @media
  screen and (max-width: 375px) and (min-width: 374px),
  screen and (min-width: 300px) and (max-width:400px){
    .order .products li{
      width: 100%!important;
    }
    .order .products li  .icon{
      display: block!important;
    }
    //.order .products .img-box{
    //  width: 150px;
    //  float: left;
    //}
    .order .products .img-box img{
      margin-right: 0!important;
    }
    .order .products li .title{
      //float: left;
      margin-top: 15px;
    }
    .order .products li .jiage{
      margin-top: 15px;
      display: block!important;
      overflow: auto;
    }
    .order .products li .jiage p{
      float: left;
      margin-right: 10px;
    }
    .chakan1{
      display: none;
    }
    .chakan{
      margin-top: 30px;
      display: block;
    }
    .jia_a{
      overflow: auto;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .order .products li .info{
      overflow: auto;
    }
    .order .products li .chakan .icon{
      width: 60px;
      height: 25px;
      margin-right: 25px;
      text-align: center;
    }
    .order .products li .chakan .icon:last-child{
      margin-right: 0;
    }
    .order .products li .chakan .div_a{
      display: flex;
      overflow: auto;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
  }
  @media screen and (max-width: 414px) and (min-width: 413px){
    .order .products li{
      width: 100%!important;
    }
    .order .products li  .icon{
      display: block!important;
    }
    //.order .products .img-box{
    //  width: 150px;
    //  float: left;
    //}
    .order .products .img-box img{
      margin-right: 0!important;
    }
    .order .products li .title{
      //float: left;
      margin-top: 15px;
    }
    .order .products li .jiage{
      margin-top: 15px;
      display: block!important;
      overflow: auto;
    }
    .order .products li .jiage p{
      float: left;
      margin-right: 10px;
    }
    .chakan1{
      display: none;
    }
    .chakan{
      margin-top: 30px;
      display: block;
    }
    .jia_a{
      overflow: auto;
      //float: right;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .order .products li .info{
      overflow: auto;
    }
    .order .products li .chakan .icon{
      width: 60px;
      height: 25px;
      margin-right: 25px;
      text-align: center;
    }
    .order .products li .chakan .icon:last-child{
      margin-right: 0;
    }
    .order .products li .chakan .div_a{
      display: flex;
      overflow: auto;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .chakan{
    display: none;
  }
  .chakan1{
    display: block;
  }
</style>
<template>
  <div class="user">
    <section>
      <h3 class="title">商品收藏</h3>
      <div class="order chakan1">
        <ul class="products">
          <li v-for="(itx) in orderLists" :key="itx.imgUrl" @mouseover="mouseOver(itx)" @mouseleave="mouseLeave(itx)" @click="getItems(itx)">
              <div class="img-box">
                <img :src="itx.imgUrl">
              </div>
              <div class="info">
                <div class="title">{{itx.name}}</div>
                <div style="display: flex;justify-content: space-evenly;" >
                  <p style="color:red;font-size:14px;;flex:0.5">{{'￥'+itx.price}}</p>
                  <div style="font-size:12px;flex:0.5;text-align: right;" >
                    <span v-show="itx.look" class="icon cursor">查看</span>
                    <span v-show="itx.delete" class="icon cursor" @click.stop="productDelete(itx.prodId)">删除</span>
                  </div>
                </div>
              </div>
          </li>
        </ul>
      </div>
      <div class="order chakan">
          <ul class="products">
            <li v-for="(itx) in orderLists" :key="itx.imgUrl" @mouseover="mouseOver(itx)" @mouseleave="mouseLeave(itx)" @click="getItems(itx)">
              <div class="li_div">
              <div class="img-box">
                <img :src="itx.imgUrl">
              </div>
              <div class="info">
                <div class="title">{{itx.name}}</div>
                <div style="display: flex;justify-content: space-evenly;" class="jiage">
                  <div class="jia_a"><p style="color:red;font-size:14px;;flex:0.5">{{'￥'+itx.price}}</p></div>
                  <div style="font-size:12px;flex:0.5;text-align: right;" class="chakan1">
                      <span v-show="itx.look" class="icon cursor">查看</span>
                      <span v-show="itx.delete" class="icon cursor" @click.stop="productDelete(itx.prodId)">删除</span>
                  </div>
                </div>
                <div style="font-size:12px;flex:0.5;text-align: center;" class="chakan">
                  <div class="div_a">
                    <span v-show="itx.look" class="icon cursor">查看</span>
                    <span v-show="itx.delete" class="icon cursor" @click.stop="productDelete(itx.prodId)">删除</span>
                  </div>
                </div>
              </div>
              </div>
            </li>
          </ul>
      </div>
    </section>
  </div>
</template>

<script>
import { productDelete } from '@/services/api.index'
// import { productFind, productDelete } from '@/services/api.index'
export default {
  data() {
    return {
      sendVisible: false,
      orderLists: []
    }
  },
  created() {
    this.getproductFind()
  },
  methods: {
    getproductFind() {
      productFind().then(res => {
        this.orderLists = []
        res.data.map(item => {
          this.orderLists.push({
            name: item.product.name,
            id: item.product.id,
            imgUrl: item.product.productImages[0].thumbnail,
            price: item.product.price,
            delete:false,
            look:false,
            prodId: item.id
          })
        })
      })
    },
    // 删除
    productDelete (id) {
      this.$confirm('确定删除此收藏？', '提示', {
      }).then(() => {
        productDelete(id).then(() => {
          this.$message.success('删除成功！')
          this.getproductFind()
        })
      })
    },
    mouseOver(itx) {
      itx.delete = true
      itx.look = true
    },
    mouseLeave(itx) {
      itx.delete = false
      itx.look = false
    },
    getItems(item) {
      window.open(`http://8.130.53.158/product/detail/${item.id}`, '_blank');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/Collection_details.vue